import React, { useState } from "react";
import { Images } from "../../Assets/Index";
import { Button, Form, Input, Spin } from "antd";
import { OtpVerify, resendOtp, userLogin } from "../../ApiServices/Apifun";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import OTPInput from "otp-input-react";
import OTPInputField from "otp-input-react";
import {
  dispatchtoast,
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../Utils";

const Verification = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const location = useLocation();
  const mobile = location?.state?.mobile;
  const isValidPhone = /^\d{10}$/.test(mobile);
  const handleLogin = (val) => {
    setLoading(true);

    const formData = new FormData();
    formData.append("mobile", val.mobile);

    userLogin(formData)
      .then((res) => {
        if (res.status) {
          setShowOtp(true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  const handleLoginOtpVerify = (val) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("mobile", mobile);
    formData.append("otp", val.otp);
    formData.append(
      "verificationToken",
      getLocalStorageItem("verificationToken")
    );
    OtpVerify(formData)
      .then((res) => {
        if (res.status) {
          setLocalStorageItem("isLoggedIn", true);
          setLocalStorageItem("accessToken", res.access_token);
          setLocalStorageItem("user", res?.user);
          setLocalStorageItem("is_new_user", res?.is_new_user);
          setShowOtp(true);
          navigate("/allGame");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  const handleResend = () => {
    if (form.getFieldValue("mobile")) {
      setPageLoader(true);

      const formData = new FormData();
      formData.append("mobile", mobile);
      resendOtp(formData)
        .then((res) => {
          if (res.status) {
            dispatchtoast(res.message);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => setPageLoader(false));
    } else {
      dispatchtoast("Please enter mobile number", true);
    }
  };
  return (
    <>
      <Spin spinning={pageLoader}>
        <div className="flex h-screen justify-center items-left">
          <div className="flex relative shadow-lg mx-8 bg-black shadow-red-500 rounded-lg justify-center  items-center flex-col px-10 md:px-18 py-20">
            <img src={Images.Logo} className="w-[300px] " alt="logo" />
            <p className="mt-2 text-white text-2xl font-normal custome">
              Verification
            </p>
            <p className="mt-2 text-white font-thin custome">
              We have sent a 6 digit code to *******{mobile?.slice(-3)},please
            </p>
            <p className=" text-white font-thin custome">
              enter code here to continue.
            </p>
            <div>
              <Form
                className="mt-12 ml-6 items-center"
                form={form}
                // onFinish={() => navigate("/home")}
                onFinish={(val) => handleLoginOtpVerify(val)}
                onFinishFailed={(err) => console.log(err)}
              >
                <Form.Item
                  name={"otp"}
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Please enter otp",
                    },
                  ]}
                >
                  <OTPInput
                    value={otp}
                    onChange={setOtp}
                    autoFocus
                    OTPLength={6}
                    otpType="number"
                    disabled={false}
                    className="gap-4"
                  >
                    {Array(6)
                      .fill(0)
                      .map((_, i) => (
                        <OTPInputField
                          key={i}
                          className="border border-gray-200 bg-black text-white w-10 h-10"
                        />
                      ))}
                  </OTPInput>
                </Form.Item>
                {/* <div className="flex text-white justify-end items-center mt-2">
                  <p
                    onClick={handleResend}
                    className="cursor-pointer font-semibold "
                  >
                    Resend OTP
                  </p>
                </div> */}
                {/* <div>
                  <NavLink
                    to={"/"}
                    className="flex text-white justify-center items-center mt-2"
                  >
                    <p className="custome text-xs text-white cursor-pointer">
                      Didn't receive any code?{" "}
                    </p>
                    <p className="custome text-xs text-yellow-300 cursor-pointer">
                      Resend
                    </p>
                  </NavLink>
                </div> */}
                <Form.Item className="text-center">
                  <Button
                    loading={loading}
                    type="default"
                    htmlType="submit"
                    className="w-3/4 m-8 custome rounded-3xl h-10 font-medium text-lg border-none
                   text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                   hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                  >
                    Continue →
                  </Button>
                </Form.Item>
              </Form>
            </div>
            <NavLink to={"/"} className="ml-8">
              <p className="m-0 custome text-xs text-yellow-300 cursor-pointer">
                Login to Another account?
              </p>
            </NavLink>
            {/* <div className="w-24 h-24 animate-pulse bg-green-600 absolute top-0 right-0 rounded-bl-full"></div>
            <div className="w-24 h-24 bg-red-600 animate-pulse absolute bottom-0 left-0 rounded-tr-full"></div> */}
          </div>
        </div>
      </Spin>
    </>
  );
};

export default Verification;
